import React from 'react';
import ContactInfoCards from './ContactInfoCards';
import ContactForm from './ContactForm';

const ContactSection = () => {
  return (
    <section id="contacto" className="py-32 bg-[#FAFAF8] relative overflow-hidden">
      <div className="container mx-auto px-6 sm:px-12 lg:px-20 relative z-10">
        {/* Section Header */}
        <div className="max-w-3xl mb-20">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-700 mb-6">
            Contacto
          </p>
          <h2 className="text-4xl sm:text-5xl font-serif font-light text-gray-900 mb-6">
            Agenda tu Consulta
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed font-light">
            Comienza tu viaje hacia la belleza natural. Contáctanos y resolveremos todas tus dudas.
          </p>
        </div>

        <div className="grid lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          <ContactInfoCards />
          <ContactForm />
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
